<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/groups">{{ $t('user_group_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('user_group_create')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើកាបញ្ចូលឈ្មោះ</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                                <label class="label-control blue">{{$t('name')}}</label>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.Name.$model"/>
                            </div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('due_day')}}</label>
                                <input type="number" class="form-control form-control-sm" v-model="model.DueDay"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        data: function(){
            return {
                model: {
                    Name: '',
                    DueDay: 0
                }
            }
        },
        created(){
            let id = this.$route.params.id;
            if(id != undefined){
                this.findById(id);
            }
        },
        validations:{
            model: {
                Name: { required }
            }
        },
        methods: {
            findById: function(id){
                var loading = this.$loading.show();
                this.$api().post('customer/type/find', { Id: id }).then(res => {
                    if(this.$isValid(res)){
                        this.model = res.data.Json.Type;
                    }
                }).finally(function(){ loading.hide(); });
            },
            clickSaveHandler: function(){
                this.$v.$touch();
                if(!this.$v.$invalid) {
                    var loading = this.$loading.show();
                    this.$api().post('customer/type/save', this.model).then(res => {
                        if (this.$isValid(res)) {
                            this.$router.push('/customer/types');
                        }
                    }).finally(function(){ loading.hide(); });
                }
            }
        }
    }
</script>